import React from 'react';
import { Tag } from 'antd';
import { backendDaysNote } from './monetizationMath';

/**
 * "backend n/N days", for a row whose backend columns cover only some of its days. Tagged blue
 * when the backend covers all of them, else orange: a backend sum then covers fewer days than the
 * GA4 columns beside it.
 */
export const BackendDays: React.FC<{ backendDays: number; days: number }> = ({
  backendDays,
  days,
}) => (
  <Tag
    color={backendDays >= days ? 'blue' : 'orange'}
    style={{ marginInlineEnd: 0 }}
    data-backend-days={`${backendDays}/${days}`}
  >
    {backendDaysNote(backendDays, days)}
  </Tag>
);
